<!--
 * @Description: 
 * @Author: yangsibo
 * @Date: 2022-09-28 16:40:26
 * @LastEditors: yangsibo
 * @LastEditTime: 2023-10-18 17:39:51
 * @FilePath: /adm.xiangli360.com/src/components/RegionAccount/Add.vue
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <div class="title-wrap">
        <h2 class="title">添加{{ accountTypeInfo.name }}账号</h2>
      </div>
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px">
        <div class="plate">
          <div class="title">账户信息</div>
          <el-form-item :label="accountTypeInfo.accountStr" prop="provinceId">
            <el-col class="col">
              <el-cascader
                class="city-select"
                ref="regionCascader"
                :props="regionProps"
                v-model="checkedRegionData"
                :placeholder="'请选择' + accountTypeInfo.accountStr"
              ></el-cascader>
              <el-input
                v-model.trim="form.provinceId"
                v-show="false"
                maxlength="30"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="登录账号" prop="loginName">
            <el-col class="col">
              <el-input
                v-model.trim="form.loginName"
                placeholder="请填写登录账号"
                maxlength="30"
              ></el-input>
            </el-col>
            <span class="login-tip">6~20位字符，可包含数字、字母。</span>
          </el-form-item>
          <el-form-item label="登录密码" prop="userPassword">
            <el-col class="col">
              <el-input
                v-model.trim="form.userPassword"
                :type="showPassword ? 'text' : 'password'"
                placeholder="请填写登录密码"
                autocomplete="new-password"
                maxlength="30"
              >
                <i
                  slot="suffix"
                  class="iconfont"
                  :class="{
                    'icon-mimaxianshi': showPassword,
                    'icon-mimayincang': !showPassword,
                  }"
                  @click="handleChangePassword('showPassword')"
                ></i>
              </el-input>
            </el-col>
            <span class="login-tip"
              >12~20位字符，包含数字、特殊字符、字母。</span
            >
          </el-form-item>
          <el-form-item label="姓名" prop="fullName">
            <el-col class="col">
              <el-input
                v-model="form.fullName"
                placeholder="请填写姓名"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="手机号码" prop="mobile">
            <el-col class="col">
              <el-input
                v-model.trim="form.mobile"
                placeholder="请填写手机号码"
                oninput="valuevalue.replace(/[^\d]/g,'')"
                maxlength="11"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="登录地址" prop="subDomain">
            <el-col class="col domain-col">
              <el-input
                v-model="form.subDomain"
                minlength="2"
                maxlength="20"
                placeholder="请填写登录地址"
              >
                <template slot="prepend">{{ accountTypeInfo.http }}</template>
                <template slot="append"
                  >{{ accountTypeInfo.path }}.xiangli360.com</template
                >
              </el-input>
            </el-col>
            <span class="login-tip tip1"
              >如登录地址为“{{
                form.subDomain ? form.subDomain : "datian"
              }}”，则登录地址为“{{ accountTypeInfo.http
              }}{{ form.subDomain ? form.subDomain : "datian"
              }}{{
                accountTypeInfo.path
              }}.xiangli360.com”；登录地址2~20位，支持数字和小写字母。</span
            >
          </el-form-item>
        </div>
        <div class="plate">
          <div class="title">业务信息</div>
          <el-form-item label="业务区域" prop="businessZoneId">
            <el-col class="col">
              <el-cascader
                ref="regionCascader"
                :options="businessZoneList"
                :props="zoneProps"
                v-model="checkedZone"
                placeholder="业务区域"
              ></el-cascader>
            </el-col>
          </el-form-item>
          <el-form-item label="业务负责人" prop="businessPersonId">
            <el-col class="col">
              <el-select
                class="city-select"
                v-model="form.businessPersonId"
                placeholder="业务负责人"
              >
                <el-option label="全部" :value="null"></el-option>
                <el-option
                  v-for="(item, index) in dutyPersonList"
                  :key="index"
                  :label="item.personName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </div>
        <el-form-item class="form-item-submit" label-width="0">
          <el-button type="primary" @click="handleSubmit('ruleForm')"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </el-main>
</template>

<script>
import common from "@/utils/common.js";
export default {
  name: "AddAccount",
  data() {
    return {
      type: 1,
      rules: {
        provinceId: [
          {
            required: true,
            trigger: "change",
          },
        ],
        loginName: [
          { required: true, message: "请填写登录账号", trigger: "blur" },
          { min: 6, max: 20, message: "长度在6到20位", trigger: "blur" },
          { trigger: "blur", validator: common.checkIdAccount },
        ],
        userPassword: [
          { required: true, message: "请填写12-20位账号密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "请输入12-20位账号密码",
            trigger: "blur",
          },
          { trigger: "blur", validator: common.checkIdPassword },
        ],
        fullName: [
          { required: true, message: "请填写联系人名称", trigger: "blur" },
        ],
        mobile: [
          { required: true, message: "请填写手机号码", trigger: "blur" },
          { validator: common.checkMobile, required: true, trigger: "blur" },
        ],
        subDomain: [
          { required: true, message: "请填写登录地址", trigger: "blur" },
          { trigger: "blur", validator: common.checkSubDomain },
          { min: 2, max: 20, message: "长度在4到20位", trigger: "blur" },
        ],
        businessZoneId: [
          { required: true, message: "请选择业务区域", trigger: "change" },
        ],
        businessPersonId: [
          { required: true, message: "请选择业务员", trigger: "change" },
        ],
      },
      form: {
        provinceId: "", //住址省id
        provinceName: "", //住址省name
        cityId: "", //住址市id
        cityName: "", //住址市name
        areaId: "", //所在地区县id
        areaName: "", //所在地区县name
        loginName: "",
        userPassword: "",
        fullName: "",
        mobile: "",
        businessPersonId: "",
        businessZoneId: "",
        subDomain: "",
        pageType: 5, // 5管理后台-添加县 6管理后台-添加市 7管理后台-添加省
      },
      checkedRegionData: [],
      regionProps: {
        lazy: true,
        lazyLoad: this.lazyLoad,
        expandTrigger: "hover",
        value: "all",
        label: "n",
      },
      businessZoneList: [], //业务区域数据
      zoneProps: {
        value: "id",
        label: "zoneName",
        children: "children",
      },
      checkedZone: [], //选中的业务区域
      dutyPersonList: [],
      showPassword: false,
      showPassword1: false,
    };
  },
  components: {},
  filters: {},
  props: ["accountType"],
  watch: {
    checkedRegionData(newVal) {
      if (newVal) {
        switch (this.accountType) {
          case "county":
            this.form.provinceId = newVal[0].i || "";
            this.form.provinceName = newVal[0].n || "";
            this.form.cityId = newVal[1].i || "";
            this.form.cityName = newVal[1].n || "";
            this.form.areaId = newVal[2].i || "";
            this.form.areaName = newVal[2].n || "";
            break;
          case "city":
            this.form.provinceId = newVal[0].i || "";
            this.form.provinceName = newVal[0].n || "";
            this.form.cityId = newVal[1].i || "";
            this.form.cityName = newVal[1].n || "";
            break;
          case "province":
            this.form.provinceId = newVal[0].i || "";
            this.form.provinceName = newVal[0].n || "";
            break;
        }
      }
    },
    checkedZone(newVal) {
      this.form.businessPersonId = "";
      this.dutyPersonList = [];
      this.form.businessZoneId =
        newVal.length > 0 ? newVal[newVal.length - 1] : "";
      newVal.length > 0 && this.getDutyPerson();
    },
  },
  computed: {
    accountTypeInfo() {
      let name = "",
        accountStr = "",
        stopLevel = 0,
        http = "",
        path = "";
      let { appEnv } = this;
      switch (this.accountType) {
        case "county":
          name = "县";
          accountStr = "省市县";
          stopLevel = 2;
          this.form.pageType = 5;
          this.rules.provinceId[0].message = "请选择省市县";
          if (appEnv == "test") {
            http = "http://";
            path = ".qx";
          } else {
            http = "https://";
            path = "-qx";
          }
          break;
        case "city":
          name = "市";
          accountStr = "省市";
          stopLevel = 1;
          this.form.pageType = 6;
          this.rules.provinceId[0].message = "请选择省市";
          if (appEnv == "test") {
            http = "http://";
            path = ".shi";
          } else {
            http = "https://";
            path = "-shi";
          }
          break;
        case "province":
          name = "省";
          accountStr = "省";
          stopLevel = 0;
          this.form.pageType = 7;
          this.rules.provinceId[0].message = "请选择省市";
          if (appEnv == "test") {
            http = "http://test-";
          } else {
            http = "https://";
          }
          path = "";
          break;
      }
      return { name, accountStr, stopLevel, http, path };
    },
  },
  created() {
    if (this.$route.query) {
      this.type = this.$route.query.type;
    }
    this.getAppEnv();
    this.getBusinessZoneData();
  },
  mounted() {},
  methods: {
    /**
     * @description: 获取应用运行环境
     * @Author: juanjuanhui
     * @Date: 2023-08-03 17:04:54
     * @return {*}
     */
    getAppEnv() {
      let reg = /^test/,
        domain = document.domain;
      if (reg.test(domain)) {
        this.appEnv = "test";
      } else {
        this.appEnv = "prod";
      }
    },
    /**
     * @description: 异步加载地区数据
     * @Author: juanjuanhui
     * @Date: 2023-08-02 14:19:56
     * @param {*} level
     * @param {*} value
     * @param {*} resolve
     * @return {*}
     */
    async lazyLoad({ level, value }, resolve) {
      let dataSource = [];
      if (level === 0) {
        dataSource = await this.getChildRegion(1);
      } else {
        dataSource = await this.getChildRegion(value.i);
      }
      resolve(
        dataSource.map((item) => ({
          ...item,
          all: { ...item },
          leaf: level >= this.accountTypeInfo.stopLevel,
        }))
      );
    },
    /**
     * @description: 根据父id查询省市县乡村子地区
     * @Author: juanjuanhui
     * @Date: 2023-08-02 15:35:57
     * @return {*}
     */
    async getChildRegion(pid) {
      const { data } = await this.$http.common.getChildRegion({ pid });
      return data || [];
    },
    /**
     * @Description: 显示/隐藏 密码
     * @Author: yangsibo
     * @Date: 2022-10-14 14:44:54
     * @return {*}
     */
    handleChangePassword(type) {
      this[type] = !this[type];
    },
    // 获取业务负责人
    getDutyPerson() {
      this.$http.common
        .getDutyPerson({ businessZoneId: this.form.businessZoneId })
        .then((res) => {
          this.dutyPersonList = res.data;
        });
    },
    // 获取业务区域数据
    getBusinessZoneData() {
      this.$http.common.getBusinessZoneList({}).then((res) => {
        this.businessZoneList = res.data;
      });
    },
    /**
     * @Description: 保存县账号
     * @Author: yangsibo
     * @Date: 2022-09-29 10:24:38
     * @param {*} formName
     * @return {*}
     */
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addCtCountyAccount();
        } else {
        }
      });
    },
    /**
     * @Description: 添加县账号
     * @Author: yangsibo
     * @Date: 2022-09-29 10:44:52
     * @return {*}
     */
    async addCtCountyAccount() {
      try {
        let { status } = await this.$http.county.addCtCountyAccount(this.form);
        if (status == 1) {
          this.$message.success(`添加${this.accountTypeInfo.name}账号成功`);
          this.$router.push({
            path: `/${this.accountType}/manage/list`,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/common.scss";
@import "@/styles/mixin.scss";

.main {
  .title-wrap {
    @include plate-title-mutil;
    height: 44px;
    border-bottom: 1px solid #efefef;
    margin-bottom: 16px;
    padding-bottom: 10px;
    box-sizing: border-box;

    .title {
      font-size: 20px;
      font-weight: bold;
      color: #018388;
    }
  }

  ::v-deep .el-form {
    width: 100%;

    .plate {
      padding: 10px 20px;

      .title {
        font-size: 18px;
        color: #333333;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        &:before {
          content: "";
          display: inline-block;
          width: 5px;
          height: 18px;
          background: #018388;
          border-radius: 3px;
          margin-right: 5px;
        }
      }
    }

    .col {
      width: 360px;

      &.domain-col {
        width: 565px;
      }
    }

    .login-tip {
      // position: absolute;
      // top: 32px;
      display: inline-block;
      margin-left: 15px;
      color: #999;
      font-size: 12px;
      &.tip1 {
        position: absolute;
        top: 32px;
        margin-left: 0;
      }
    }

    .form-item-submit {
      display: flex;
      align-items: center;
      justify-content: center;

      .el-form-item__content {
        margin-right: 450px;
      }
    }

    .el-form-item {
      margin-bottom: 22px;
    }

    .el-form-item__content {
      display: flex;

      .el-form-item__error {
        position: relative;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 10px;
        padding-top: 0;
      }
    }
  }
}
</style>
